import React from 'react';

import { serverService } from '../../_services/server.service';
import { toast } from 'react-toastify';
import { Row, Col, Form, Button, Card, Modal } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import { RouteComponentProps, Link } from 'react-router-dom';
import './PlansPage.scss';
import { config } from '../../_helpers/C';
import i18n from 'i18next';
import ModalCalendly from "../_modals/ModalCalendly";
import { withRouter } from 'react-router-dom';


const qs = require('query-string');

const checkIcon = (
  <svg style={{ marginTop: '-4px', minWidth: 25 }} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" width="24" height="24" rx="12" fill="#0696F6" fillOpacity="0.1" />
    <path fillRule="evenodd" clipRule="evenodd" d="M17.5965 7.39004L10.4365 14.3L8.5365 12.27C8.1865 11.94 7.6365 11.92 7.2365 12.2C6.8465 12.49 6.7365 13 6.9765 13.41L9.2265 17.07C9.4465 17.41 9.8265 17.62 10.2565 17.62C10.6665 17.62 11.0565 17.41 11.2765 17.07C11.6365 16.6 18.5065 8.41004 18.5065 8.41004C19.4065 7.49004 18.3165 6.68004 17.5965 7.38004V7.39004Z" fill="#35BFF4" />
  </svg>
);

const popularIcon = (
  <svg style={{ position: 'absolute', right: '8.5px' }} width="76" height="28" viewBox="0 0 76 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="76" height="28" rx="14" fill="#0696F6" fillOpacity="0.1" />
    <path d="M13.5727 19V8.81818H17.202C17.9941 8.81818 18.6504 8.96236 19.1707 9.25071C19.6911 9.53906 20.0805 9.93347 20.339 10.4339C20.5976 10.9311 20.7268 11.4912 20.7268 12.1143C20.7268 12.7408 20.5959 13.3042 20.3341 13.8047C20.0756 14.3018 19.6845 14.6963 19.1608 14.9879C18.6404 15.2763 17.9858 15.4205 17.197 15.4205H14.7013V14.1179H17.0578C17.5583 14.1179 17.9643 14.0317 18.2758 13.8594C18.5874 13.6837 18.8161 13.4451 18.9619 13.1435C19.1077 12.8419 19.1807 12.4988 19.1807 12.1143C19.1807 11.7299 19.1077 11.3885 18.9619 11.0902C18.8161 10.7919 18.5857 10.5582 18.2709 10.3892C17.9593 10.2202 17.5483 10.1357 17.0379 10.1357H15.1089V19H13.5727ZM25.5294 19.1541C24.8135 19.1541 24.1887 18.9901 23.6551 18.6619C23.1215 18.3338 22.7072 17.8748 22.4122 17.2848C22.1172 16.6948 21.9697 16.0054 21.9697 15.2166C21.9697 14.4245 22.1172 13.7318 22.4122 13.1385C22.7072 12.5452 23.1215 12.0845 23.6551 11.7564C24.1887 11.4283 24.8135 11.2642 25.5294 11.2642C26.2453 11.2642 26.8701 11.4283 27.4037 11.7564C27.9373 12.0845 28.3516 12.5452 28.6466 13.1385C28.9416 13.7318 29.089 14.4245 29.089 15.2166C29.089 16.0054 28.9416 16.6948 28.6466 17.2848C28.3516 17.8748 27.9373 18.3338 27.4037 18.6619C26.8701 18.9901 26.2453 19.1541 25.5294 19.1541ZM25.5344 17.9062C25.9984 17.9062 26.3828 17.7836 26.6878 17.5384C26.9927 17.2931 27.2181 16.9666 27.3639 16.5589C27.5131 16.1513 27.5876 15.7022 27.5876 15.2116C27.5876 14.7244 27.5131 14.277 27.3639 13.8693C27.2181 13.4583 26.9927 13.1286 26.6878 12.88C26.3828 12.6314 25.9984 12.5071 25.5344 12.5071C25.067 12.5071 24.6792 12.6314 24.371 12.88C24.0661 13.1286 23.839 13.4583 23.6899 13.8693C23.5441 14.277 23.4711 14.7244 23.4711 15.2116C23.4711 15.7022 23.5441 16.1513 23.6899 16.5589C23.839 16.9666 24.0661 17.2931 24.371 17.5384C24.6792 17.7836 25.067 17.9062 25.5344 17.9062ZM30.7483 21.8636V11.3636H32.2V12.6016H32.3243C32.4105 12.4425 32.5348 12.2585 32.6972 12.0497C32.8596 11.8409 33.085 11.6586 33.3733 11.5028C33.6617 11.3438 34.0428 11.2642 34.5168 11.2642C35.1333 11.2642 35.6834 11.42 36.1673 11.7315C36.6512 12.0431 37.0307 12.4922 37.3058 13.0788C37.5843 13.6655 37.7235 14.3714 37.7235 15.1967C37.7235 16.022 37.5859 16.7296 37.3108 17.3196C37.0357 17.9062 36.6579 18.3587 36.1773 18.6768C35.6967 18.9917 35.1482 19.1491 34.5317 19.1491C34.0677 19.1491 33.6882 19.0713 33.3932 18.9155C33.1015 18.7597 32.8728 18.5774 32.7071 18.3686C32.5414 18.1598 32.4138 17.9742 32.3243 17.8118H32.2348V21.8636H30.7483ZM32.205 15.1818C32.205 15.7187 32.2829 16.1894 32.4387 16.5938C32.5944 16.9981 32.8198 17.3146 33.1148 17.5433C33.4098 17.7687 33.771 17.8814 34.1986 17.8814C34.6427 17.8814 35.0139 17.7637 35.3122 17.5284C35.6105 17.2898 35.8359 16.9666 35.9884 16.5589C36.1441 16.1513 36.222 15.6922 36.222 15.1818C36.222 14.678 36.1458 14.2256 35.9933 13.8246C35.8442 13.4235 35.6188 13.107 35.3172 12.875C35.0189 12.643 34.646 12.527 34.1986 12.527C33.7677 12.527 33.4031 12.638 33.1048 12.8601C32.8099 13.0821 32.5861 13.392 32.4337 13.7898C32.2812 14.1875 32.205 14.6515 32.205 15.1818ZM44.2263 15.8331V11.3636H45.7178V19H44.2561V17.6776H44.1766C44.0009 18.0852 43.7192 18.425 43.3314 18.6967C42.9469 18.9652 42.468 19.0994 41.8946 19.0994C41.4041 19.0994 40.9699 18.9917 40.5921 18.7763C40.2175 18.5575 39.9226 18.2344 39.7071 17.8068C39.495 17.3793 39.3889 16.8506 39.3889 16.2209V11.3636H40.8754V16.0419C40.8754 16.5623 41.0196 16.9766 41.308 17.2848C41.5963 17.593 41.9709 17.7472 42.4316 17.7472C42.71 17.7472 42.9867 17.6776 43.2618 17.5384C43.5402 17.3991 43.7706 17.1887 43.9529 16.907C44.1385 16.6252 44.2296 16.2673 44.2263 15.8331ZM49.2016 8.81818V19H47.7151V8.81818H49.2016ZM53.4237 19.169C52.9398 19.169 52.5023 19.0795 52.1112 18.9006C51.7201 18.7183 51.4102 18.4548 51.1816 18.1101C50.9562 17.7654 50.8435 17.3428 50.8435 16.8423C50.8435 16.4115 50.9263 16.0568 51.0921 15.7784C51.2578 15.5 51.4815 15.2796 51.7632 15.1172C52.045 14.9548 52.3598 14.8321 52.7078 14.7493C53.0558 14.6664 53.4105 14.6035 53.7718 14.5604C54.2291 14.5073 54.6003 14.4643 54.8854 14.4311C55.1704 14.3946 55.3776 14.3366 55.5068 14.2571C55.6361 14.1776 55.7007 14.0483 55.7007 13.8693V13.8345C55.7007 13.4003 55.5781 13.0639 55.3328 12.8253C55.0909 12.5866 54.7296 12.4673 54.249 12.4673C53.7485 12.4673 53.3541 12.5784 53.0658 12.8004C52.7807 13.0192 52.5835 13.2628 52.4742 13.5312L51.0771 13.2131C51.2429 12.7491 51.4848 12.3745 51.803 12.0895C52.1245 11.8011 52.4941 11.5923 52.9117 11.4631C53.3293 11.3305 53.7684 11.2642 54.2291 11.2642C54.5341 11.2642 54.8572 11.3007 55.1986 11.3736C55.5433 11.4432 55.8648 11.5724 56.1631 11.7614C56.4647 11.9503 56.7116 12.2204 56.9039 12.5717C57.0961 12.9197 57.1922 13.3722 57.1922 13.929V19H55.7405V17.956H55.6808C55.5847 18.1482 55.4405 18.3371 55.2483 18.5227C55.0561 18.7083 54.8092 18.8625 54.5075 18.9851C54.2059 19.1077 53.8447 19.169 53.4237 19.169ZM53.7469 17.9759C54.1579 17.9759 54.5092 17.8946 54.8009 17.7322C55.0959 17.5698 55.3196 17.3577 55.472 17.0959C55.6278 16.8307 55.7057 16.5473 55.7057 16.2457V15.2614C55.6527 15.3144 55.5499 15.3641 55.3975 15.4105C55.2483 15.4536 55.0776 15.4917 54.8854 15.5249C54.6932 15.5547 54.5059 15.5829 54.3236 15.6094C54.1413 15.6326 53.9888 15.6525 53.8662 15.669C53.5779 15.7055 53.3144 15.7668 53.0757 15.853C52.8404 15.9392 52.6515 16.0634 52.509 16.2259C52.3698 16.3849 52.3002 16.5971 52.3002 16.8622C52.3002 17.2301 52.436 17.5085 52.7078 17.6974C52.9796 17.883 53.326 17.9759 53.7469 17.9759ZM59.1721 19V11.3636H60.6089V12.5767H60.6885C60.8277 12.1657 61.0729 11.8426 61.4243 11.6072C61.7789 11.3686 62.18 11.2493 62.6274 11.2493C62.7202 11.2493 62.8296 11.2526 62.9555 11.2592C63.0848 11.2659 63.1859 11.2741 63.2588 11.2841V12.706C63.1991 12.6894 63.0931 12.6712 62.9406 12.6513C62.7881 12.6281 62.6357 12.6165 62.4832 12.6165C62.1319 12.6165 61.8187 12.6911 61.5436 12.8402C61.2718 12.986 61.0564 13.1899 60.8973 13.4517C60.7382 13.7102 60.6586 14.0052 60.6586 14.3366V19H59.1721Z" fill="#0595F5" />
  </svg>
)

const arrowIcon = (
  <svg style={{ marginLeft: '10px', marginTop: 5 }} xmlns="http://www.w3.org/2000/svg" width="29" height="17" viewBox="0 0 29 17" fill="none">
    <path d="M22.5 9.38886H6.5C6.00223 9.38886 5.61111 8.99775 5.61111 8.49997C5.61111 8.0022 6.00223 7.61108 6.5 7.61108H22.5C22.9978 7.61108 23.3889 8.0022 23.3889 8.49997C23.3889 8.99775 22.9978 9.38886 22.5 9.38886Z" fill="white" />
    <path d="M18.0555 15.6111C17.939 15.6125 17.8234 15.5895 17.7162 15.5436C17.6091 15.4977 17.5127 15.4298 17.4333 15.3444C17.0778 14.9889 17.0778 14.4378 17.4333 14.0822L23.0333 8.48222L17.4333 2.88222C17.0778 2.52667 17.0778 1.97555 17.4333 1.62C17.7889 1.26444 18.34 1.26444 18.6955 1.62L24.9178 7.84222C25.2733 8.19778 25.2733 8.74889 24.9178 9.10444L18.6955 15.3267C18.5178 15.5044 18.2867 15.5933 18.0733 15.5933L18.0555 15.6111Z" fill="white" />
  </svg>
)

interface MyProps {
  stripe: any;
  elements: any;
  handleResult: any;
}
interface MyState {
  _from: string,
  _email: string,
  _scan_token: string,
  showModalCalendly: boolean,
  isMonthly: boolean,
  changing: boolean,
  availableLicenses: any,
}


class PlansPage extends React.Component<
  MyProps & RouteComponentProps,
  MyState
> {
  constructor(props) {
    super(props);

    let allProps = this.props;
    let _from = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })._from;
    let _email = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })._email;
    let _scan_token = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })._scan_token;

    console.log("_from: " + _from);
    console.log("_email: " + _email);
    console.log("_scan_token: " + _scan_token);



    this.state = {
      _from: _from,
      _email: _email,
      _scan_token: _scan_token,
      showModalCalendly: false,
      isMonthly: true,
      changing: false,
      availableLicenses: [],
    };
    this.doFetchAllLicensePrices();
    this.onChangeToMonthly = this.onChangeToMonthly.bind(this);
    this.onChangeToYearly = this.onChangeToYearly.bind(this);
    this.handleModalShow = this.handleModalShow.bind(this);
  }



  render() {
    const { isMonthly, _from, availableLicenses, _email, _scan_token } = this.state;

    // console.log("availableLicenses: " + JSON.stringify(availableLicenses));
    

    const handleTryNowClick = () => {
      console.log("Link clicked");
      
      console.log("availableLicenses: " + JSON.stringify(availableLicenses));

      let path;
      // Your path logic here...
      // Use this.props.history to navigate
      if (path.startsWith('http')) {
        window.location.href = path;
      } else {
        this.props.history.push(path, { /* state */ });
      }


    };

    return (

      <>

        <div className="n_vox plans_page" style={{ opacity: this.state.changing ? 0.3 : 1 }}>
          <div className="flexify_center_gap">
            <h2 style={{ marginRight: '52px' }}>All Plans</h2> <div className="monthly_annual">
              <button onClick={this.onChangeToMonthly} className={isMonthly ? 'active' : ''}>Monthly</button>
              <button onClick={this.onChangeToYearly} className={isMonthly ? '' : 'active'}>Annually 20% off</button></div>
          </div>
          <div className='plans_page'>

            {/* {JSON.stringify(this.state.availableLicenses[0])} */}
            {availableLicenses.map((cardinfo, index) => (
              <Col>
 
                <Card className="custom_card" key={cardinfo.id}>
                  <h4>{cardinfo.name} {index == 2 ? popularIcon : ''}</h4>
                  <h6>{cardinfo.localized_description}</h6>

                  {(cardinfo.id !== 'enterprise_license' && cardinfo.id !== 'free_license') &&
                    <h5>{cardinfo.defaultPrice}{cardinfo.currency == 'eur' ? '€' : cardinfo.currency}{cardinfo.type === 'stripe' && cardinfo.recurrenceInterval !== null ? <span>{"/" + cardinfo.recurrenceInterval}</span> : <span></span>}</h5>
                  }

                  {(cardinfo.id === 'free_license') &&
                    <h5>0{availableLicenses[2].currency == 'eur' ? '€' : cardinfo.currency}<span>/{isMonthly ? 'month' : 'month'}</span></h5>
                  }

                  {(cardinfo.id === 'enterprise_license') &&
                    <h5>Get Quote</h5>
                  }

         
                  {(cardinfo.id === 'free_license') ?
                      <a
                        href={
                          cardinfo.id === "free_license" ?
                            (_from === 'email' ? '/home' : 'https://www.voxcollector.com/teamscan/') :
                            '/payment-page'
                        }
                        className={ 
                          (_from !== 'email' && cardinfo.id === "free_license") ? 'green_button' : ''
                        }
                        target={_from === 'email' && cardinfo.id === "free_license" ? "_parent" : "_self"}
                        // You might also want to pass state if needed, but this is not standard for <a> tags and would need a different approach
                        >
                        <button><Trans>{cardinfo.cta_btn}</Trans> {arrowIcon}</button>
                        </a> : ''
                  }

                  {(cardinfo.id !== 'enterprise_license' && cardinfo.id !== 'free_license') ?
                    <Link 
                    // target="_parent" 
                    className={
                      (((_from !== 'email' && cardinfo.id === "free_license") || (_from === 'email' && index == 1)) ? 'green_button' : '')
                    
                    }
                    target={ _from === 'email' && cardinfo.id === "free_license" ? "_parent" : "_self" }
                    to={{ pathname: cardinfo.id === "free_license" ? (_from === 'email' && cardinfo.id === "free_license" ? '/home':'https://www.voxcollector.com/teamscan/') : '/payment-page', 
                    state: { cardinfo, isMonthly, index }, }}> 
                    <button><Trans>{cardinfo.cta_btn}</Trans>  {arrowIcon}</button> </Link> : ''}



                      
                  {cardinfo.id === 'enterprise_license' ?
                    <button onClick={this.handleModalShow}>{cardinfo.cta_btn} {arrowIcon}</button> : ''}
                  {/* a */}
                  <br />

                  {cardinfo.benefitsArray.map((benefit, key) => (<p key={key}>{checkIcon} <Trans>{benefit}</Trans></p>))}


                  {(_from === 'email' && cardinfo.children) &&
                    <div style={{ border: '2px solid #35BFF4', borderRadius: '10px', backgroundColor: '#F6F6F6', padding: '8px'}}>
                      <h4>{cardinfo.children[0].name}</h4>
                      <h6>{cardinfo.children[0].localized_description}</h6>
                      <h5>{cardinfo.children[0].defaultPrice}{cardinfo.children[0].currency == 'eur' ? '€' : cardinfo.children[0].currency}{cardinfo.children[0].type === 'stripe' && cardinfo.children[0].recurrenceInterval !== null ? <span>{"/" + cardinfo.children[0].recurrenceInterval}</span> : <span>- <Trans>trans_33_one_shot</Trans></span>}</h5>
                      
                      
                      <a
                        href={cardinfo.children[0].paymentLink + '?prefilled_email=' + _email + '&client_reference_id=' + _scan_token}
                        className={'green_button'}
                        target={"_blank"}
                      >
                        <button><Trans>{cardinfo.children[0].cta_btn}</Trans> {arrowIcon}</button>
                      </a>
                      
                    </div>
                  }

                </Card>

              </Col>))}

          </div>
          <ModalCalendly
            show={this.state.showModalCalendly}
            theProps={this.props}
            onHide={this.handleModalShow}
          />
        </div>

      </>
    );
  }


  doFetchAllLicensePrices(the_type = this.state.isMonthly) {
    this.setState({ changing: true });
    serverService.getAvailableLicenses(the_type).then((result) => {
      if (result.status == 1) {
        let myArray = result.data;

        this.setState({ availableLicenses: myArray });
        this.setState({ changing: false });
      }
    });
  }

  onChangeToMonthly() {
    this.setState({ isMonthly: true });
    this.doFetchAllLicensePrices(true)
  }
  onChangeToYearly() {
    this.setState({ isMonthly: false });
    this.doFetchAllLicensePrices(false)
  }
  handleModalShow() {
    this.setState({
      showModalCalendly: !this.state.showModalCalendly,
    });
  }

}


export { PlansPage };